<template>
  <v-list class="mt-12">
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        exact
        active-class="nav-link-active"
        :to="{ name: 'dashboardMentee', params: { id: getUserId() } }"
      >
        <span class="home-link" v-if="isExpanded">Home</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'coursesGridMember' }"
      >
        <span class="learning-link" v-if="isExpanded">Learning Resources</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-school</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'assessments' }"
      >
        <span class="assessment-link" v-if="isExpanded">Assessments</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-certificate-outline</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'documentsListMember' }"
      >
        <span class="documents-link" v-if="isExpanded">Documents</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-file-document-box-outline</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'tools' }"
      >
        <span class="assessment-link" v-if="isExpanded">Tools</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-certificate-outline</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'user' }"
      >
        <span class="profile-link" v-if="isExpanded">Profile</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-account</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
  </v-list>
</template>

<script>
import userMixin from "@/mixins/userMixin"
export default {
  mixins: [userMixin],
  props: {
    isExpanded: { type: Boolean, default: true }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

a:link {
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 600;
}

.nav-link {
  color: $dark-grey;
}

.nav-link-active {
  color: $light-grey;
}

.v-list-item {
  line-height: 8em;
}

span.home-link {
  text-transform: none !important;
  color: $dark-grey;
  font-style: italic;
}

span.learning-link {
  color: $dark-blue;
}

span.assessment-link {
  color: $light-yellow;
}

span.documents-link {
  color: $orange;
}

span.profile-link {
  color: $light-grey;
}
</style>
